// extracted by mini-css-extract-plugin
export var downloadButton = "styles-module--downloadButton--2rddn";